import { render } from "./algolia-search-drawer.vue?vue&type=template&id=2c670d98"
import script from "./algolia-search-drawer.vue?vue&type=script&lang=js"
export * from "./algolia-search-drawer.vue?vue&type=script&lang=js"

import "./algolia-search-drawer.vue?vue&type=style&index=0&id=2c670d98&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__